// 开发环境需要覆盖的设置添加在 .env.local文件中
export const BD_API = process.env.REACT_APP_API_INSIGHTS

export const POSITION_API = process.env.REACT_APP_POSITION_INSIGHTS
export const TAG_API = process.env.REACT_APP_TAG_INSIGHTS
export const REPORT_API = process.env.REACT_APP_REPORT_INSIGHTS
export const AUTH_API = process.env.REACT_APP_AUTH_API

export const MAP_API = process.env.REACT_APP_API_INDOOR
export const ECAR_API = process.env.REACT_APP_API_ECAR
export const KONG_API = process.env.REACT_APP_API_KONG
export const AUTH_URL = process.env.REACT_APP_API_AUTH
export const BRAND_API = process.env.REACT_APP_API_BRAND
export const APPID = process.env.REACT_APP_ID
export const DMP_API = process.env.REACT_APP_API_DMP

export const AS_API = process.env.REACT_APP_API_ASSETS
export const AMAP_KEY = "3ac73a2d4a821dc96635d6cf0c8d88b9"
export const API_BI = process.env.REACT_APP_API_BI
export const API_LBI = process.env.REACT_APP_API_LBI
export const API_AOI = process.env.REACt_APP_API_AOI
export const API_BIG_DATA = process.env.REACT_APP_API_BIG_DATA
export const GRID_API = process.env.REACT_APP_API_GRID
export const GRID_HEAT_API = process.env.REACT_APP_API_GRID_HEAT
export const POI_REPORT = {
  aa:
    "https://s3.cn-northwest-1.amazonaws.com.cn/wz-dmp-image/img/2019/04/d866011a-c759-4af0-87d3-08705d1ee39c.jpg",
}
const location = window.location
export const COOKIE_DOMAIN = location.hostname.replace(
  /^.*((\.[\w-]+){2})$/,
  "$1"
)
export const CHANNEL_NAME_REPLACE = {
  _ACTIVE_: false,
  Madi: "小米™",
  蜻蜓FM: "魅族™",
  百寻: "vivo™",
  佳投: "华为™",
}

export const AOI_WHITE_LIST = {
  // 5PuydkMvkxR
  // B000A87TR2
  '5PuydkMvkxR': {
    id: 'B000A87TR2',
    address: "北京市朝阳区国家体育场北路会议中心",
    name: "国家会议中心",
    ratio: 10,
    trend: true,
    graph: true,
  },
  // 5PuyibPgF5q
  // B000A7R05I
  '5PuyibPgF5q': {
    id: 'B000A7R05I',
    address: "北京市朝阳区亮马桥路50号商务写字楼",
    name: "北京燕莎中心",
    ratio: 10,
    trend: true,
    graph: true,
  },
  // 5PuunJhSxmK
  // B00155L44U
  '5PuunJhSxmK': {
    id: 'B00155L44U',
    address: "上海市浦东新区陆家嘴西路168号",
    name: "正大广场",
    ratio: 10,
    trend: true,
    graph: true,
  },
  // 5PuydiA4KuK
  // B000A7BU79
  '5PuydiA4KuK': {
    id: 'B000A7BU79',
    address: "北京市西城区阜成门外大街甲9号",
    name: "北京国宾酒店",
    ratio: 10,
    trend: true,
    graph: true,
  },
  // 5PuyibhNimL
  // B000A7GVH0
  '5PuyibhNimL': {
    id: 'B000A7GVH0',
    address: "北京市朝阳区朝阳门外大街1号京广中心",
    name: "京广中心",
    ratio: 10,
    trend: true,
    graph: true,
  },
  // B0FFFFZ2VB
  // B0FFFFZ2VB: {
  //   address: "",
  //   name: "华发商都商场",
  //   ratio: 10,
  //   trend: true,
  //   graph: true,
  // }, // 华发商都商场 弘桥商城 B0FFFYWT4I
  // B02F400E8Y
  // 5PuSprjTWVC
  '5PuSprjTWVC': {
    id: 'B02F400E8Y',
    address: "",
    name: "珠海免税商场",
    ratio: 10,
    trend: true,
    graph: true,
  }, // 珠海免税商场 国贸购物广场a3e8341c1c57ef8c4afd3f73
  // B0FFGJ5C5X
  // 5PuSqDbJn9g
  '5PuSqDbJn9g': {
    id: 'B0FFGJ5C5X',
    address: "",
    name: "珠海市人民医院",
    ratio: 10,
    trend: true,
    graph: true,
  }, // 珠海市人民医院
  // B02F400E5M
  // 5PuSqDcRGca
  '5PuSqDcRGca': {
    id: 'B02F400E5M',
    address: "",
    name: "珠海市香洲区第一小学",
    ratio: 5,
    trend: true,
    graph: true,
  }, // 珠海市香洲区第一小学
  // B0FFH3X7MH
  // 5PuSprdcw5G
  '5PuSprdcw5G': {
    id: 'B0FFH3X7MH',
    address: "",
    name: "扬名广场一期购物中心",
    ratio: 10,
    trend: true,
    graph: true,
  }, // 扬名广场一期购物中心
  // 7aea43b7ceef72f87c29bd7f
  // 5PuSqD9e7q8
  "5PuSqD9e7q8": {
    id: '7aea43b7ceef72f87c29bd7f',
    address: "",
    name: "珠海市公安局交警支队车管所",
    ratio: 10,
    trend: true,
    graph: true,
  }, // 珠海市公安局交警支队车管所
}

export const HEALTH_AUTH_LIST = ["17349796813", "13426394050"]
export const GRAPH_AUTH_LIST = [
  "jingyu.qiu",
  "vincent.tao",
  "aaron.qi",
  "yolanda.zhao",
  "nico.tong",
  "vincent.zhang",
  "vincent.wen",
  "haofen.wang",
]
